import * as React from 'react';

export const useDeleteKeyPress = (onDeletePress: (e: KeyboardEvent) => void) => {
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Delete') {
        onDeletePress(e);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onDeletePress]);
};